export default __webpack_public_path__ + "static/media/warning-badge.e0fd0f36.svg";